export class UnapprovedRemittance {
    constructor(
        //public UnapprovedRemittanceId?: number,
        public ClientId: number = 0,
        public CarrierId: string = '',
        public CheckRef: number = 0,
        public CheckNum: string = '',
        public CheckAmount: number = 0,
        public DepositDate: Date = new Date(),
        public DateSubmitted: Date = new Date(),
        public SubmittedBy: string = '',
        public Resolved: boolean = false,
        public ResolvedBy?: string,
        public DateResolved?: Date,
        public Comment: string = '',
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/models/unapproved-remittance.model.ts